import { render, staticRenderFns } from "./daiban.vue?vue&type=template&id=4059a3b2&scoped=true"
import script from "./daiban.vue?vue&type=script&lang=js"
export * from "./daiban.vue?vue&type=script&lang=js"
import style0 from "./daiban.vue?vue&type=style&index=0&id=4059a3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059a3b2",
  null
  
)

export default component.exports